import {routeAuthentication, routeAuthenticationAdmin} from "../../base/utils";

export const subscriptionsRoutes = [
    {
        path: '/subscriptions/new/:process_id',
        name: 'New Subscription',
        component: () => import('../views/NewSubscription.vue')
    },
    {
        path: '/subscriptions/preview/:process_id',
        name: 'Preview',
        props: {preview: true},
        component: () => import('../views/NewSubscription.vue'),
        beforeEnter: routeAuthenticationAdmin
    },
    {
        path: '/subscriptions/',
        name: 'SubscriptionsList',
        component: () => import('../views/SubscriptionsList.vue'),
        beforeEnter: routeAuthentication,
        meta: {title: 'Minhas Inscrições'}
    },
    {
        path: '/subscriptions/backup',
        name: 'SubscriptionsBackup',
        component: () => import('../views/SubscriptionsBackup.vue'),
        meta: {title: 'Gerar backup'}
    },
];
